export default __webpack_public_path__ + "static/media/OpenSans 1.a42bbe68.ttf";